/* eslint-disable no-restricted-syntax,no-continue */
import React from 'react';
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import SharedProgrammeCard from './shared_programme_card';
import { calendarDayFromJSDate } from '../../services/dates';
import { sharedProgrammeDurationDays } from '../../services/programmes';
import { isProgrammeEnrollmentCompleted } from '../../services/my_day';
// import { currentUserAccessibleMembershipTierIDsSelector } from '../../reducers/user_reducer';

export const RECOMMENDATION_SOURCES_URL =
  'https://www.smorg.io/sources-of-recommendations';

const buildGroups = (
  sharedProgrammes,
  categoryConfigurations,
  enrolledInSharedProgrammeID,
) => {
  const groups = (categoryConfigurations || []).map((cc) => ({
    categoryTag: cc.categoryTag,
    sharedProgrammes: [],
  }));

  for (const categoryConf of categoryConfigurations || []) {
    for (const programmeID of categoryConf.orderedProgrammeIDs || []) {
      const sharedProgramme = sharedProgrammes.find(
        (p) => p.programmeID === programmeID,
      );
      if (sharedProgramme) {
        if (
          enrolledInSharedProgrammeID &&
          sharedProgramme.id === enrolledInSharedProgrammeID
        ) {
          continue;
        }
        const groupIndex = groups.findIndex(
          (g) => g.categoryTag === categoryConf.categoryTag,
        );
        if (
          groups[groupIndex].sharedProgrammes.every(
            (p) => p.id !== sharedProgramme.id,
          )
        ) {
          groups[groupIndex].sharedProgrammes.push(sharedProgramme);
        }
      }
    }
  }

  for (const sharedProgramme of sharedProgrammes) {
    if (
      enrolledInSharedProgrammeID &&
      sharedProgramme.id === enrolledInSharedProgrammeID
    ) {
      continue;
    }
    for (const categoryTag of sharedProgramme.categoryTags || []) {
      const groupIndex = groups.findIndex((g) => g.categoryTag === categoryTag);
      if (groupIndex >= 0) {
        if (
          groups[groupIndex].sharedProgrammes.every(
            (p) => p.id !== sharedProgramme.id,
          )
        ) {
          groups[groupIndex].sharedProgrammes.push(sharedProgramme);
        }
      } else {
        groups.push({ categoryTag, sharedProgrammes: [sharedProgramme] });
      }
    }
  }

  if (enrolledInSharedProgrammeID) {
    const enrolledInSharedProgramme = sharedProgrammes.find(
      (sp) => sp.id === enrolledInSharedProgrammeID,
    );
    if (enrolledInSharedProgramme) {
      groups.unshift({
        categoryTag: 'Selected program',
        sharedProgrammes: [enrolledInSharedProgramme],
      });
    }
  }

  return groups;
};

const SharedProgrammesList = ({
  sharedProgrammes,
  categoryConfigurations,
  onClickSharedProgramme,
  cardWidth,
  currentProgrammeEnrollment,
  showStartButton,
  onClickStart,
}) => {
  const enrolledInSharedProgrammeID =
    currentProgrammeEnrollment?.sharedProgrammeID;

  const today = calendarDayFromJSDate(new Date());

  const groups = buildGroups(
    sharedProgrammes,
    categoryConfigurations,
    enrolledInSharedProgrammeID,
  );

  console.log({ groups });

  const groupsWithVisibleProgrammes = groups.filter((group) => {
    const visibleProgrammes = group.sharedProgrammes; /* .filter(
      (sharedProgramme) => {
        const needsMembershipUpgrade =
          !sharedProgramme.availableInMembershipTierIDs ||
          sharedProgramme.availableInMembershipTierIDs.every(
            (mtid) => !accessibleMembershipTierIDs.includes(mtid),
          );

        return !needsMembershipUpgrade;
      },
    ) */
    return visibleProgrammes.length > 0;
  });

  // const accessibleMembershipTierIDs = useSelector(
  //   currentUserAccessibleMembershipTierIDsSelector,
  // );

  return (
    <>
      {groupsWithVisibleProgrammes.map((group) => {
        const visibleProgrammes = group.sharedProgrammes; /* .filter(
          (sharedProgramme) => {
            const needsMembershipUpgrade =
              !sharedProgramme.availableInMembershipTierIDs ||
              sharedProgramme.availableInMembershipTierIDs.every(
                (mtid) => !accessibleMembershipTierIDs.includes(mtid),
              );

            return !needsMembershipUpgrade;
          },
        ) */
        return (
          <Grid container key={group.categoryTag}>
            <Grid item xs={12}>
              <h2>{group.categoryTag}</h2>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                {visibleProgrammes.map((sharedProgramme) => (
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={3}
                    lg={2}
                    key={sharedProgramme.id}>
                    <div style={{ display: 'flex', overflowX: 'auto' }}>
                      <SharedProgrammeCard
                        key={sharedProgramme.id}
                        sharedProgrammeId={sharedProgramme.id}
                        title={sharedProgramme.title}
                        shortDescription={sharedProgramme.shortDescription}
                        coverImageUrl={sharedProgramme.coverImageUrl}
                        needsMembershipUpgrade={false}
                        onClickSharedProgramme={onClickSharedProgramme}
                        cardWidth={cardWidth}
                        isEnrolled={
                          enrolledInSharedProgrammeID &&
                          enrolledInSharedProgrammeID === sharedProgramme.id
                        }
                        isCompleted={isProgrammeEnrollmentCompleted(
                          currentProgrammeEnrollment,
                          sharedProgrammeDurationDays(sharedProgramme),
                          today,
                        )}
                      />
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
      <Grid container>
        {groupsWithVisibleProgrammes.length === 0 && (
          <div style={{ height: '30px' }}>&nbsp;</div>
        )}
        {groupsWithVisibleProgrammes.length > 0 && (
          <Grid item xs={12}>
            <h2>All programs</h2>
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {sharedProgrammes.map((sharedProgramme) => {
              /* const needsMembershipUpgrade =
                !sharedProgramme.availableInMembershipTierIDs ||
                sharedProgramme.availableInMembershipTierIDs.every(
                  (mtid) => !accessibleMembershipTierIDs.includes(mtid),
                );

              if (needsMembershipUpgrade) {
                // Don't display this program
                return null;
              } */
              if (
                enrolledInSharedProgrammeID &&
                sharedProgramme.id === enrolledInSharedProgrammeID
              ) {
                return null;
              }

              return (
                <Grid item key={sharedProgramme.id} xs={6} sm={4} md={3} lg={2}>
                  <SharedProgrammeCard
                    key={sharedProgramme.id}
                    sharedProgrammeId={sharedProgramme.id}
                    title={sharedProgramme.title}
                    shortDescription={sharedProgramme.shortDescription}
                    coverImageUrl={sharedProgramme.coverImageUrl}
                    needsMembershipUpgrade={false}
                    onClickSharedProgramme={onClickSharedProgramme}
                    cardWidth={cardWidth}
                    isEnrolled={
                      enrolledInSharedProgrammeID &&
                      enrolledInSharedProgrammeID === sharedProgramme.id
                    }
                    isCompleted={isProgrammeEnrollmentCompleted(
                      currentProgrammeEnrollment,
                      sharedProgrammeDurationDays(sharedProgramme),
                      today,
                    )}
                    showStartButton={showStartButton}
                    onClickStart={() =>
                      onClickStart && onClickStart(sharedProgramme.id)
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ padding: '20px 0 10px', fontSize: '12px' }}>
          <a
            href={RECOMMENDATION_SOURCES_URL}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none' }}>
            View recommendation sources
          </a>
        </Grid>
      </Grid>
    </>
  );
};

SharedProgrammesList.propTypes = {
  sharedProgrammes: PropTypes.arrayOf().isRequired,
  categoryConfigurations: PropTypes.arrayOf(PropTypes.shape({})),
  onClickSharedProgramme: PropTypes.func.isRequired,
  cardWidth: PropTypes.number,
  currentProgrammeEnrollment: PropTypes.shape({
    sharedProgrammeID: PropTypes.string,
  }),
  showStartButton: PropTypes.bool,
  onClickStart: PropTypes.func,
};

SharedProgrammesList.defaultProps = {
  categoryConfigurations: null,
  cardWidth: null,
  currentProgrammeEnrollment: null,
  showStartButton: false,
  onClickStart: null,
};

export default SharedProgrammesList;
